var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: {
        id: _vm.id_modal,
        tabindex: "-1",
        role: "dialog",
        "aria-hidden": "true",
        "data-backdrop": _vm.backdrop,
      },
    },
    [
      _c(
        "div",
        {
          class: "modal-dialog " + _vm.class_modal,
          attrs: { role: "document" },
        },
        [
          _c(
            "div",
            {
              class: "modal-content " + _vm.class_modal_content,
              attrs: { id: "content-" + _vm.id_modal },
            },
            [
              !_vm.lock
                ? _c(
                    "div",
                    {
                      staticClass:
                        "modal-header d-flex justify-content-end align-center p-1 border-0 shadow-sm",
                      staticStyle: { "background-color": "#f9fafb" },
                    },
                    [
                      _vm._t("header"),
                      _vm._v(" "),
                      _vm.backdrop === "static"
                        ? _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-sm py-1 px-2 border-0 text-danger b-close",
                              attrs: {
                                type: "button",
                                id: "btn_close-" + _vm.id_modal,
                                "data-dismiss": "modal",
                                "aria-label": "Close",
                                title: "Fechar",
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "fas fa-times font-size-09",
                              }),
                            ]
                          )
                        : _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-tiny border-0 py-1 px-2 b-close",
                              attrs: {
                                type: "button",
                                id: "btn_close-" + _vm.id_modal,
                                "data-dismiss": "modal",
                                "aria-label": "Close",
                                title: "Fechar",
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "fas fa-times font-size-09",
                              }),
                            ]
                          ),
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "modal-body position-relative border-0" },
                [_vm._t("default")],
                2
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-primary",
          attrs: {
            id: "btn_toggle-" + _vm.id_modal,
            type: "button",
            "data-toggle": "modal",
            "data-target": "#" + _vm.id_modal,
            hidden: "",
          },
        },
        [_vm._v("\n        Toggle\n    ")]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }